// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type InfoCircle24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle24Filled: FC<InfoCircle24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M11.1 16.5h1.8v-5.4h-1.8v5.4Zm.9-7.2a.87.87 0 0 0 .641-.259.87.87 0 0 0 .259-.641.87.87 0 0 0-.259-.641A.87.87 0 0 0 12 7.5a.87.87 0 0 0-.641.259.87.87 0 0 0-.259.641.87.87 0 0 0 .259.641A.87.87 0 0 0 12 9.3ZM12 21a8.762 8.762 0 0 1-3.51-.709 9.089 9.089 0 0 1-2.857-1.924 9.089 9.089 0 0 1-1.924-2.857A8.764 8.764 0 0 1 3 12c0-1.245.236-2.415.709-3.51a9.089 9.089 0 0 1 1.924-2.857A9.089 9.089 0 0 1 8.49 3.709 8.764 8.764 0 0 1 12 3c1.245 0 2.415.236 3.51.709a9.089 9.089 0 0 1 2.857 1.924 9.089 9.089 0 0 1 1.924 2.857A8.762 8.762 0 0 1 21 12a8.762 8.762 0 0 1-.709 3.51 9.089 9.089 0 0 1-1.924 2.857 9.089 9.089 0 0 1-2.857 1.924A8.762 8.762 0 0 1 12 21Z" />
        </svg>
    );
};

export default InfoCircle24Filled;
